import { useQuery } from 'react-query';

import { useCurrentAssetId } from 'src/Hooks/Shared/useCurrentAssetId';
import { bankAccountsApi } from 'src/Services/API';

const useFetchBankAccounts = () => {
  const assetId = useCurrentAssetId();

  return useQuery({
    queryKey: ['fetch-bank-accounts', assetId],
    queryFn: async () => {
      if (!assetId) throw new Error('No assetId provided');
      const response = await bankAccountsApi.bankAccountsControllerFindAllByAsset(assetId);
      return response.data;
    },
    enabled: !!assetId,
  });
};

export default useFetchBankAccounts;
